import { useEffect } from 'react';
import logger from 'utils/logger';
import { NIC_RINGTONE_URL } from 'stores/nic/utils/helpers';
var incomingCallSound = new Audio(NIC_RINGTONE_URL);
incomingCallSound.loop = true;
incomingCallSound.volume = 0.8;
var stopRingtone = function () {
    incomingCallSound.pause();
    incomingCallSound.currentTime = 0;
};
/** Drops the ringtone lock only when it belongs to this tab. */
var releaseRingtoneLock = function () {
    var tabId = sessionStorage.getItem('tabId');
    var ringtoneTabId = localStorage.getItem('ringtoneTabId');
    if (tabId && (ringtoneTabId === null || ringtoneTabId === void 0 ? void 0 : ringtoneTabId.startsWith("".concat(tabId, ":")))) {
        localStorage.removeItem('ringtoneTabId');
    }
};
export var useIncomingCallRingtone = function (_a) {
    var isIncomingCall = _a.isIncomingCall, isWebRtcOwner = _a.isWebRtcOwner, contactId = _a.contactId, setIsWindowOpen = _a.setIsWindowOpen;
    useEffect(function () {
        var _a;
        if (!isIncomingCall) {
            releaseRingtoneLock();
            stopRingtone();
            return;
        }
        setIsWindowOpen(true);
        // Read the owner from localStorage as well, so a tab whose store flag is
        // stale after a takeover cannot ring alongside the real owner.
        var tabId = sessionStorage.getItem('tabId');
        var ownsWebRtc = !!tabId &&
            isWebRtcOwner &&
            tabId === localStorage.getItem('webRtcOwnerTabId');
        if (!ownsWebRtc || !contactId) {
            // Covers losing ownership mid-ring: hand the lock back and go quiet.
            releaseRingtoneLock();
            stopRingtone();
            return;
        }
        var _b = ((_a = localStorage.getItem('ringtoneTabId')) === null || _a === void 0 ? void 0 : _a.split(':')) || [], lockTabId = _b[0], lockContactId = _b[1];
        // Another tab is already ringing this same call. A lock left over from an
        // earlier contact is ignored on purpose - it must not silence this one.
        if (lockContactId === contactId && lockTabId !== tabId)
            return;
        localStorage.setItem('ringtoneTabId', "".concat(tabId, ":").concat(contactId));
        incomingCallSound.play().catch(function (error) {
            logger.logError('Failed to play incoming call sound', {}, error);
        });
    }, [isIncomingCall, isWebRtcOwner, contactId, setIsWindowOpen]);
};
